/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { LOCATION_CHANGE } from 'connected-react-router';
import { createLogic } from 'redux-logic';

import { requestStateConfig } from 'components/layouts/Navigation/RequestStateConfig';
import { requestStatusMapping } from 'services/Rest';

const failedApiLogic = createLogic({
  type: LOCATION_CHANGE,
  process({ getState }, dispatch, done) {
    const state = getState();
    const { requestStatus, router } = state;
    const {
      location: { pathname }
    } = router;

    const pathKey = pathname.slice(1);
    const requestState = requestStateConfig[pathKey];
    if (requestState) {
      const failedRequestStates = requestState.filter(
        (request) => requestStatus[request] === 'ERROR'
      );

      failedRequestStates.forEach((requestStatus) => {
        dispatch({
          type: 'CLEAR_REQUEST_STATUS',
          payload: {
            requestStatus
          }
        });

        const requestFunction = requestStatusMapping[requestStatus];
        if (requestFunction) {
          requestFunction();
        }
      });
    }

    done();
  }
});

export default failedApiLogic;
